import script from "./StatusTag.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusTag.vue?vue&type=script&setup=true&lang=js"

import "./StatusTag.vue?vue&type=style&index=0&id=678c9e9a&lang=css"

const __exports__ = script;

export default __exports__